package com.hyperether.goodjob.repository.remote.model

import com.hyperether.goodjob.util.FileType

sealed class Resource<T>(
    val data: T? = null,
    val text: String? = null,
    val errorInternalCode: Int? = null
) {
    class Success<T>(data: T?) : Resource<T>(data)
    class Error<T>(text: String?, errorInternalCode: Int? = null, data: T? = null) :
        Resource<T>(data, text, errorInternalCode)
}

data class FileResult(val fileData: ByteArray, val fileType: FileType)